"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_arrow_min_down_style_1 = __importDefault(require("./uicon.arrow.min.down.style"));
class UiconArrowMinDown extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { d: "M15.5002 20H15.4942C15.3572 20.0002 15.2226 19.9643 15.1039 19.8958C14.9852 19.8273 14.8867 19.7287 14.8182 19.61L11.1102 13.17C11.0382 13.0527 11 12.9177 11 12.78C11 12.6423 11.0382 12.5073 11.1102 12.39C11.1775 12.2719 11.2748 12.1736 11.3923 12.1051C11.5098 12.0366 11.6433 12.0003 11.7792 12H19.2192C19.3566 11.999 19.4918 12.0344 19.6112 12.1024C19.7305 12.1705 19.8298 12.2689 19.8989 12.3876C19.968 12.5064 20.0045 12.6413 20.0047 12.7786C20.005 12.916 19.9689 13.051 19.9002 13.17L16.1762 19.61C16.1077 19.7287 16.0092 19.8272 15.8905 19.8956C15.7718 19.9641 15.6372 20.0001 15.5002 20Z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconArrowMinDown.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconArrowMinDown.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_arrow_min_down_style_1.default)(UiconArrowMinDown);
//# sourceMappingURL=uicon.arrow.min.down.js.map